function slugify(str, allowDots = false) {
  return str.trim().toLowerCase().replace(/[-_\s]+/g, "-").replace(/ä/g, "ae").replace(/ö/g, "oe").replace(/ü/g, "ue").replace(/Ä/g, "AE").replace(/Ö/g, "OE").replace(/Ü/g, "UE").replace(/ß/g, "ss").replace(/&/g, "und").replace(/\+/g, "-").replace(allowDots ? /[^a-z\d-.]/g : /[^a-z\d-]/g, "").replace(/^\.|-\.|-\.-|\.-|\.$/g, "").replace(/-+/g, "-").replace(/^-|-$/g, "");
}
export {
  slugify as default
};
